module.exports = __webpack_public_path__ + "static/media/IMG_3281.9c2af529.JPG";